"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var DefaultButton_1 = require("../../../../../../common/components/presentation/Buttons/DefaultButton");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var backToFinanceButtonStyles_1 = require("./backToFinanceButtonStyles");
var BackToFinanceButton = function (_a) {
    var startConfigurationSourceUrl = _a.startConfigurationSourceUrl;
    var _b;
    var styles = backToFinanceButtonStyles_1.default();
    var financeConfigurationUrl = (_b = startConfigurationSourceUrl) === null || _b === void 0 ? void 0 : _b.replace('exterior/paint/', 'summary/finance/');
    var navigateToFinanceConfiguration = function () { return (window.location.href = financeConfigurationUrl); };
    return (<DefaultButton_1.default onClick={navigateToFinanceConfiguration} className={[styles.buttonWrapper]} variant="outlined" dataTest={'checkout:finance_section:button'}>
      <Translation_1.default id={'trans__checkout__extras_page__finance_back_cta'} className={styles.buttonLabel}/>
    </DefaultButton_1.default>);
};
exports.default = BackToFinanceButton;
